<template>
  <twitch-player :channel="channel" :width="width" :height="height"></twitch-player>
</template>

<script>
import TwitchPlayer from 'vue-twitch-player';

export default {
  name: 'TPlayer',
  components: {
    TwitchPlayer
  },
  data () {
    return {
      channel: 'niller2005',
      width: '100%',
      height: '100%'
    };
  }
};
</script>
